import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { EnrichedBulletList } from '../interactions/EnrichedBulletList.jsx'

/**
 * RisksCard — enriched bullets with mandatory severity chip (high/med/low).
 * catalog #6, prep-risks.
 * Error state shown when any bullet is missing severity.
 */
export function RisksCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []
  const hasUnseverered = items.some((i) => i.text && !i.suffix)
  const hasBullets = items.some((i) => i.text)

  return (
    <CardFrame
      kind="prep"
      icon="◭"
      iconClass="rust"
      title="Risks"
      prompt="What could go wrong?"
      state={disabled ? 'locked' : hasUnseverered ? 'error' : hasBullets ? 'filled' : 'empty'}
      data-testid="prep-card-prep-risks"
      className="prepcard"
    >
      <EnrichedBulletList
        items={items}
        onChange={onChange}
        suffixType="severity"
        maxItems={10}
        maxChars={140}
        placeholder="A risk or concern…"
        disabled={disabled}
      />
      {hasUnseverered && !disabled && (
        <p style={{ fontSize: 11, color: 'var(--color-danger-text)', padding: '0 14px 8px', fontStyle: 'italic' }}>
          Set severity on every item.
        </p>
      )}
    </CardFrame>
  )
}
